export default function preciseToSecs(date) {
	const seconds = date.getSeconds();
	date.setMinutes(date.getMinutes() + (seconds <= 30 ? 0 : 1));
	date.setSeconds(seconds <= 30 ? 30 : 0);
	date.setMilliseconds(0);

	return date;
}

let sidebarCollapsed = false;

export function toggleSidebarCollapsed() {
	sidebarCollapsed = !sidebarCollapsed;
}

export function isSidebarCollapsed() {
	return sidebarCollapsed;
}
